import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./car-finance-menu.module.css";
import { carFinance, articles } from "../../../data/car-finance";
import { ListItem } from "../list-item/list-item";
import { ListWrapper } from "../list-wrapper/list-wrapper";
import { useContext } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { ListSnippetItem } from "../list-snippet-item/list-snippet-item";
import { parentLinks } from "../../../data/parent-menu";
export const CarFinanceMenu = ({ isMobile  })=>{
    const { logicStore  } = useContext(SharedUiHeaderV2Context);
    const { handleTrackEvent  } = logicStore;
    const sectionTitle = carFinance.sectionTitle;
    const carFinanceNavItems = carFinance.navItems;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                className: styles.carFinanceItemWrapper,
                children: sectionTitle && /*#__PURE__*/ _jsx(ListWrapper, {
                    heading: sectionTitle,
                    children: /*#__PURE__*/ _jsx(_Fragment, {
                        children: carFinanceNavItems.map((item)=>/*#__PURE__*/ _jsx("li", {
                                className: styles.listItem,
                                children: /*#__PURE__*/ _jsx(ListItem, {
                                    label: item.label,
                                    href: item.href,
                                    handleClickEvent: ()=>handleTrackEvent({
                                            name: "click",
                                            category: "mega menu",
                                            label: parentLinks.CARFINANCE,
                                            action: item.label,
                                            value: item.label
                                        })
                                })
                            }, item.label))
                    })
                })
            }),
            /*#__PURE__*/ _jsx("nav", {
                className: styles.helpfulArticles,
                children: articles.sectionTitle && /*#__PURE__*/ _jsx(ListWrapper, {
                    heading: articles.sectionTitle,
                    href: articles.href,
                    urlText: articles.sectionLink,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.CARFINANCE,
                            action: articles.sectionTitle,
                            value: articles.sectionLink
                        }),
                    children: /*#__PURE__*/ _jsx(_Fragment, {
                        children: articles.navArticles.map((article)=>/*#__PURE__*/ _jsx(ListSnippetItem, {
                                smallImage: true,
                                isMobile: isMobile,
                                heading: article.title,
                                href: article.href,
                                image: article.image,
                                alt: article.alt,
                                handleTrackEvent: ()=>handleTrackEvent({
                                        name: "click",
                                        category: "mega menu",
                                        label: parentLinks.CARFINANCE,
                                        action: articles.sectionTitle,
                                        value: article.title
                                    })
                            }, article.title))
                    })
                })
            })
        ]
    });
};
